import { memo } from 'react'
import { Handle, Position, type NodeProps, type Node } from '@xyflow/react'
import type { FlowCanvasNodeData } from './flowGraphAdapter'

function FlowStepNodeInner({ data, selected }: NodeProps<Node<FlowCanvasNodeData>>) {
  const handles = data.sourceHandles
  const n = handles.length

  return (
    <div
      className={`relative overflow-visible rounded-lg border-2 bg-white shadow-sm min-w-[168px] max-w-[240px] transition-shadow ${
        selected ? 'border-blue-500 shadow-md ring-2 ring-blue-100' : 'border-slate-200 hover:border-slate-300'
      }`}
    >
      <Handle
        type="target"
        position={Position.Top}
        className="!bg-slate-400 !border-0 !w-2.5 !h-2.5"
        aria-label="Entrada"
      />

      {data.isStart ? (
        <div className="absolute -top-7 left-1/2 -translate-x-1/2 whitespace-nowrap rounded bg-emerald-600 px-1.5 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-white">
          Início
        </div>
      ) : null}

      {selected && data.onSetAsStart && !data.isStart ? (
        <button
          type="button"
          onClick={(e) => {
            e.stopPropagation()
            data.onSetAsStart?.()
          }}
          className="absolute -bottom-9 left-1/2 z-10 -translate-x-1/2 whitespace-nowrap rounded border border-emerald-200 bg-white px-2 py-0.5 text-[10px] font-medium text-emerald-700 shadow-sm hover:bg-emerald-50"
        >
          Definir como início
        </button>
      ) : null}

      <div className="rounded-t-md border-b border-slate-100 bg-gradient-to-b from-slate-50 to-white px-3 py-2">
        <p className="truncate text-sm font-semibold text-slate-900">{data.label}</p>
        <p className="truncate text-[11px] capitalize text-slate-500">{data.stepType.replace(/_/g, ' ')}</p>
      </div>

      <div className="relative h-6">
        {handles.map((h, i) => {
          const leftPct = n <= 1 ? 50 : 8 + (i / Math.max(n - 1, 1)) * 84
          return (
            <Handle
              key={h.id}
              type="source"
              position={Position.Bottom}
              id={h.id}
              style={{ left: `${leftPct}%` }}
              className="!bg-slate-500 !border-0 !w-2.5 !h-2.5"
              title={h.shortLabel}
            />
          )
        })}
      </div>
    </div>
  )
}

export const StepNode = memo(FlowStepNodeInner)
